<template>
  <div class="container">
    <br />

    <div class="button-group" role="group">
      <a @click="filterDate('today')" type="button" class="btn btn-dark-purple mb-3 me-2">Today</a>
      <a @click="filterDate('thisMonth')" type="button" class="btn btn-dark-purple mb-3 me-2">This month</a>
      <a @click="filterDate('lastMonth')" type="button" class="btn btn-dark-purple mb-3 me-2">Last month</a>
      <a @click="filterDate('thisYear')" type="button" class="btn btn-dark-purple mb-3 me-2">This year</a>
      <a @click="filterDate('total')" type="button" class="btn btn-dark-purple mb-3 me-2">Total</a>
      <button type="button" class="btn btn-dark-purple mb-3 me-2" data-bs-toggle="modal"
              data-bs-target="#staticBackdrop">
        Custom
      </button>
    </div>
    <span v-if="loading"><font-awesome-icon icon="fa-solid fa-sync fa-10x" spin /></span>
    <p v-else>Date filter {{ fromDate }} - {{ toDate }}</p>

    <br />
    <h4 class="text-left text-lg m-5 font-weight-bold m-2">
      <font-awesome-icon :icon="['fas', 'coins']" /> Finances </h4>
    <br/>

    <div class="row">

      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Total platform revenue</h5>
            <p class="card-text">
              {{ platformTotalRevenue }} {{ selectedCurrencySymbol }}
            </p>
          </div>
        </div>

      </div>

      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Total creator earnings</h5>
            <p class="card-text">
              {{ platformCreatorEarnings }} {{ selectedCurrencySymbol }}
            </p>
          </div>
        </div>
      </div>


      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Total platform earnings</h5>
            <p class="card-text">
              {{ platformEarnings }} {{ selectedCurrencySymbol }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Total subscriptions</h5>
            <p class="card-text">
              {{ totalSubscriptionCount }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Total payments</h5>
            <p class="card-text">
              {{ totalPayments }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Average spending price</h5>
            <p class="card-text">
              {{ averageSpendingPrice }} {{ selectedCurrencySymbol }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <h4 class="text-left text-lg font-weight-bold m-2">
      <font-awesome-icon :icon="['fas', 'user']" />  Users and creators
    </h4>
    <br/>

    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Total active users</h5>
            <p class="card-text">
              {{ totalActiveFans }}
            </p>
            <p class="card-text text-primary">At least 1 succesful payment!</p>
          </div>
        </div>
      </div>


      <div class="col-lg-6 col-md-6">
        <div class="card cursor-pointer" data-bs-toggle="modal" data-bs-target="#categoryModal">
          <div class="card-body">
            <h5 class="card-title">Total active creators</h5>
            <p class="card-text">
              {{ totalActiveCreators }}
            </p>
            <p class="card-text text-primary">Click here &#11206;</p>
          </div>
        </div>

      </div>
    </div>

    <br/>
    <h4 class="text-left text-lg m-5 font-weight-bold">
      <font-awesome-icon :icon="['fas', 'balance-scale-right']" />
      Subscriptions</h4>
    <br/>

    <div class="row">

      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">New subscribers (<b>amount</b>)</h5>
            <p class="card-text">
              {{ newSubscribersAmount }} {{ selectedCurrencySymbol }}
            </p>
            <p class="card-text text-primary"></p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Revenue per new subscriber</h5>
            <p class="card-text">
              {{ revenuePerNewSubscriber }} {{ selectedCurrencySymbol }}
            </p>
            <p class="card-text text-primary"></p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">New subscribers (<b>count</b>)</h5>
            <p class="card-text">
              {{ newSubscribersCount }}
            </p>
            <p class="card-text text-primary"></p>
          </div>
        </div>
      </div>



    </div>


    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Cancelled subscribers (<b>amount</b>)</h5>
            <p class="card-text">
              {{ cancelledSubscribersAmount }} {{ selectedCurrencySymbol }}
            </p>
            <p class="card-text text-primary"></p>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Cancelled subscribers (<b>count</b>)</h5>
            <p class="card-text">
              {{ cancelledSubscribersCount }}
            </p>
            <p class="card-text text-primary"></p>
          </div>
        </div>
      </div>

    </div>


  </div>
  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
       aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">Dashboard date filter</h1>
          <button id="closeDashModal" type="button" class="btn-close" data-bs-dismiss="modal"
                  aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="fromDate" class="form-label">From date</label>
            <input type="date" class="form-control me-1" id="fromDate" v-model="fromDate"
                   @input="formatCustomDate('fromDate')">
          </div>
          <div class="mb-3">
            <label for="toDate" class="form-label">To date</label>
            <input type="date" class="form-control me-1" id="toDate" v-model="toDate"
                   @input="formatCustomDate('toDate')">
          </div>
          <div class="mb-3">
            <label for="currency" class="form-label">Currency</label>
            <select class="form-control" id="currency" v-model="selectedCurrency">
              <option v-for="currency in currencies" :value="currency.currency">{{ currency.currency }}</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="fetchDate(fromDate, toDate, selectedCurrency)" type="button"
                  class="btn btn-dark-purple me-2">Search</button>
          <a @click="clearFilter" type="button" class="btn btn-danger">Clear</a>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="categoryModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
       aria-labelledby="categoryBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">Active creators by categories</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-for="(category, index) in channelCategories" :key="index" class="col-lg-4 col-md-6">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{ category.name }}</h5>
                <p class="card-text">
                  {{ category.channels_count }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      currencies: [],

      platformTotalRevenue: 0,
      platformCreatorEarnings: 0,
      platformEarnings: 0,
      totalPayments: 0,
      totalSubscriptionCount: 0,
      averageSpendingPrice: 0,
      totalActiveFans: 0,
      totalActiveCreators: 0,
      newSubscribersAmount: 0,
      newSubscribersCount: 0,
      cancelledSubscribersAmount: 0,
      cancelledSubscribersCount: 0,
      revenuePerNewSubscriber: 0,

      fromDate: '',
      toDate: '',
      channelCategories: [],
      selectedCurrency: 'EUR',
      selectedCurrencySymbol: '€',
      loading: true,
    };
  },
  methods: {
    filterDate(filterParam) {
      const date = new Date();
      if (filterParam === 'today') {
        this.fromDate = new Date();
        this.toDate = new Date();
        this.fromDate = this.fromDate.toISOString().split('T')[0];
        this.toDate = this.toDate.toISOString().split('T')[0];
      }
      else if (filterParam === 'thisYear') {
        this.fromDate = new Date(date.getFullYear(), 0, 1);
        this.toDate = new Date(date.getFullYear(), 11, 31);
        this.fromDate = this.formatDate(this.fromDate);
        this.toDate = this.formatDate(this.toDate);
      }
      else if (filterParam === 'thisMonth') {
        this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
        this.toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.fromDate = this.formatDate(this.fromDate);
        this.toDate = this.formatDate(this.toDate);
      }
      else if (filterParam === 'total') {

        this.fromDate = this.formatDate(new Date(2018, 0, 1));
        this.toDate = this.formatDate(date);
      } else if (filterParam === 'lastMonth') {
        const year = date.getMonth() === 0 ? date.getFullYear() - 1 : date.getFullYear();
        const month = date.getMonth() === 0 ? 11 : date.getMonth() - 1;

        this.fromDate = new Date(year, month, 1);
        this.toDate = new Date(year, month + 1, 0);

        this.fromDate = this.formatDate(this.fromDate);
        this.toDate = this.formatDate(this.toDate);
      }
      this.fetchDate(this.fromDate, this.toDate, this.selectedCurrency);
    },
    clearFilter() {
      this.selectedCurrency = 'EUR';
      this.selectedCurrencySymbol = '€';
      this.filterDate('thisMonth');
    },
    fetchDate(fromDate, toDate, currency) {
      this.fetchActiveChannels(fromDate, toDate);
      this.fetchActiveFans(fromDate, toDate);
      this.fetchDashboardStats(fromDate, toDate, currency);
      this.fetchDashboardPledgeStats(fromDate, toDate);
      this.fetchSubCount(fromDate, toDate, currency)
      this.closeModal();
    },
    fetchDashboardStats(fromDate, toDate, currency) {
      this.loading = true;
      if (fromDate > toDate) {
        [this.toDate, this.fromDate] = [this.fromDate, this.toDate];
        [toDate, fromDate] = [fromDate, toDate];
      }
      axios.get(`/admin/dashboard?from_date=${fromDate}&to_date=${toDate}&currency=${currency}`)
          .then(response => {

            this.platformEarnings = response.data.platformEarnings;
            this.platformTotalRevenue = response.data.platformRevenue;
            this.platformCreatorEarnings = response.data.platformCreatorEarnings;
            this.totalPayments = response.data.totalRecords;
            this.averageSpendingPrice = (response.data.costAverage);

            this.selectedCurrencySymbol = response.data.selectedCurrency;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
    },
    fetchDashboardPledgeStats(fromDate, toDate) {
      this.loading = true;
      if (fromDate > toDate) {
        [this.toDate, this.fromDate] = [this.fromDate, this.toDate];
        [toDate, fromDate] = [fromDate, toDate];
      }
      axios.get(`/admin/dashboard/pledges?from_date=${fromDate}&to_date=${toDate}`)
          .then(response => {
            this.newSubscribersAmount = response.data.newSubscribersAmount;
            this.newSubscribersCount = response.data.newSubscribersCount;
            this.revenuePerNewSubscriber = response.data.revenuePerNewSubscriber.toFixed(2);
            this.cancelledSubscribersAmount = response.data.cancelledSubscribersAmount;
            this.cancelledSubscribersCount = response.data.cancelledSubscribersCount;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
    },
    fetchActiveChannels(fromDate, toDate) {
      this.loading = true;
      this.totalActiveCreators = 0;
      if (fromDate > toDate) {
        [this.toDate, this.fromDate] = [this.fromDate, this.toDate];
        [toDate, fromDate] = [fromDate, toDate];
      }
      axios.get(`admin/dashboard/active/channels?from_date=${fromDate}&to_date=${toDate}`)
          .then(response => {
            this.channelCategories = response.data;
            this.channelCategories.forEach((el) => this.totalActiveCreators += el.channels_count)
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
          });
    },
    fetchActiveFans(fromDate, toDate) {
      this.loading = true;
      if (fromDate > toDate) {
        [this.toDate, this.fromDate] = [this.fromDate, this.toDate];
        [toDate, fromDate] = [fromDate, toDate];
      }
      axios.get(`admin/dashboard/active/fans?from_date=${fromDate}&to_date=${toDate}`)
          .then(response => {
            this.totalActiveFans = response.data;
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
          });
    },
    fetchCurrencies() {
      axios.get(`/admin/currency`)
          .then(response => {
            this.currencies = response.data.data;
          })
          .catch(error => {
            console.log(error);
          });
    },

    fetchSubCount(fromDate, toDate, currency) {
      this.loading = true;
      if (fromDate > toDate) {
        // keep component state in sync with the swapped parameters
        [this.toDate, this.fromDate] = [this.fromDate, this.toDate];
        // swap the local variables so the request uses the correct range
        [toDate, fromDate] = [fromDate, toDate];
      }
      axios.get(
          `/admin/dashboard/count-of-sub-payments?from_date=${fromDate}` +
          `&to_date=${toDate}&currency=${currency}`
      )
          .then(response => {
            this.totalSubscriptionCount = response.data;
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
          });
    },

    closeModal() {
      document.getElementById('closeDashModal').click();
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatCustomDate(date) {
      let dateValue = this[date];

      // Check if the input is a valid date
      if (dateValue) {
        // Convert the input to a Date object
        const dateObject = new Date(dateValue);
        this[date] = this.formatDate(dateObject);
      }
    }
  },
  mounted() {
    this.fetchCurrencies();
    this.filterDate('thisMonth');

  },

};
</script>